import { Tooltip, makeStyles, Icon } from '@material-ui/core';
import React from 'react';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

export interface CustomTooltipProps {
  text: string;
  driverName: string;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  text,
  driverName,
}: CustomTooltipProps) => {
  const useStyles = makeStyles({
    active: {
      color: '#999c9fff',
      margin: '0 0 2px 2px',
      fontSize: 16,
      fontFamily: 'Rubik',
      fontWeight: 600,
      textTransform: 'none',
    },
    customTooltip: {
      '& .MuiTooltip-arrow': {
        color: '#999c9fff', // Change to your desired color
      },
      backgroundColor: 'white',
      fontFamily: 'Rubik',
      border: '1px solid #999c9fff',
      color: '#171F46',
      fontWeight: 300,
      fontSize: '11px',
    },
  });

  const classes = useStyles();
  const config = JSON.parse(localStorage.getItem('mappingConfig') || '');
  const driverMapping = config.driverMapping;
  const driver = driverName?.includes('Acq. Framework')
    ? driverName
    : driverName?.split('(')[0].trim();
  const title =
    text ||
    driverMapping?.find(
      (d: any) =>
        d?.label == driver ||
        d?.label == driverName ||
        d?.label.includes(driver) ||
        d?.label.includes(driverName),
    )?.definition;
  return (
    <Tooltip
      placement="top"
      arrow
      classes={{ tooltip: classes.customTooltip }}
      title={title || 'No Driver Definition Found'}
    >
      <Icon component={InfoOutlinedIcon} className={classes.active} />
    </Tooltip>
  );
};

export default CustomTooltip;
